export default __webpack_public_path__ + "static/media/2632.01eea8be.jpg";